import React, { useEffect } from "react";
import addIcon from "../../../assets/images/icons/add-icon.png";
import UploadJson from "../../../components/modals/UploadJson";
import AddMotivatonalManagerOverview from "./AddMotivatonalManagerOverview";
const AddMotivatonalManagerButton = ({
                                       setCurrentModal,
                                       currentModal,
                                       openModal,
                                       modalAddBtn,
                                       selectedPlanId,
                                       handleFileUpload,
                                       handleSubmit,
                                       uploadedJson,
                                       planData,
                                       errorMessage,
                                       fileName,
                                       onAddNewPlanClick,
                                     }) => {
  const closeModal = () => {
    setCurrentModal(null);
  };

  useEffect(() => {
    if (selectedPlanId) {
      openModal(2);
    }
  }, [ selectedPlanId]);

  return (
    <div>
      <button
        className="btn btn-primary"
        onClick={() => {
          onAddNewPlanClick();
          openModal(1);
        }}
      >
        <img src={addIcon} alt="Add New Plan" />
        <span>{modalAddBtn}</span>
      </button>
      {currentModal === 1 && (
        <UploadJson
          onOpenModal2={() => openModal(2)}
          onClose={closeModal}
          onFileUpload={handleFileUpload}
          fileName={fileName}
          errorMessage={errorMessage}
        />
      )}
      {currentModal === 2 && (
        <AddMotivatonalManagerOverview
          jsonData={uploadedJson}
          onClose={closeModal}
          onSubmit={handleSubmit}
          planData={planData}
          selectedPlanId={selectedPlanId}
        />
      )}
    </div>
  );
};

export default AddMotivatonalManagerButton;
